import { ArticleStoreType } from "store/type";

export const initGlobalState: ArticleStoreType = {
  articleGroups: [],
  getArticleGroupsLoading: false,
  saveArticleGroupLoading: false,
  updateArticleGroupLoading: false,
  deleteArticleGroupLoading: false,
  saveArticleLoading: false,
  articlesLoading: false,
  articles: [],
  updateArticleLoading: false,
  deleteArticleLoading: false
};
